// @flow
import * as React from 'react';
import {
  useAppointmentReminderRequiredAgentConfirmationWillBeLateMutation
} from '../../../../../../shared';
import { useConfirm } from '@coverright/features';
import { theme } from '../../../../../../app/theme';
import { MenuItem } from '@mui/material';


export const ArAgentConfirmationToggleRunningLateOption = ({id, onClick}: {id: string, onClick: () => void}) => {
  const [request] = useAppointmentReminderRequiredAgentConfirmationWillBeLateMutation({
    variables: {id}
  })
  const confirm = useConfirm(theme);

  const handleClick = () => confirm({
    title: 'Confirmation',
    content: 'Are you running late?',
    okButtonTitle: 'Yes',
    cancelButtonTitle: 'No',
    width: 400,
  }).then(val => {
    if (val) {
      request();
    }
  })

  return (
    <MenuItem onClick={() => {
      onClick();
      handleClick();
    }}>Running late/CSR to call</MenuItem>
  );
};
